import { StepCompletionEventName } from '../types/GTM'

const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || ''

const getHeadTagManagerScript = () => {
  const headScript = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');`

  const headScriptElement = document.createElement('script')
  headScriptElement.innerHTML = headScript
  return headScriptElement
}

const getBodyNoscript = () => {
  const bodyNoScript = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`
  const bodyNoscript = document.createElement('noscript')
  bodyNoscript.innerHTML = bodyNoScript
  return bodyNoscript
}

// const getOptimizeAntiFlickerScript = () => {
//   const optimizeStyle = '.async-hide { opacity: 0 !important}'
//   const optimizeAntiFlickerScript = `
//     (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
//     h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
//     (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
//     })(window,document.documentElement,'async-hide','dataLayer',4000,
//     {'CONTAINER_ID':true});`
//   const antiFlickerStyle = document.createElement('style')
//   antiFlickerStyle.innerHTML = optimizeStyle

//   const antiFlickerScript = document.createElement('script')
//   antiFlickerScript.innerHTML = optimizeAntiFlickerScript

//   return { antiFlickerStyle, antiFlickerScript }
// }

/** index.tsx only initializes this if NODE.ENV === 'production'
 *
 * Remove if statement from index.tsx to test
 */
const initializeGTM = (): void => {
  const headTagScript = getHeadTagManagerScript()
  const bodyNoscript = getBodyNoscript()

  document.body.insertBefore(bodyNoscript, document.body.childNodes[0])
  document.head.insertBefore(headTagScript, document.head.childNodes[0])
}

const addPageView = (pageUrl: string, pageTitle: string): void => {
  const windowWithDatalayer = window as any
  if (windowWithDatalayer.dataLayer) {
    const dataLayer = windowWithDatalayer.dataLayer
    dataLayer.push({
      event: 'VirtualPageview',
      virtualPageURL: pageUrl,
      virtualPageTitle: pageTitle
    })
  }
}

const addFormSubmit = (formName: string): void => {
  const windowWithDatalayer = window as any
  if (windowWithDatalayer.dataLayer) {
    const dataLayer = windowWithDatalayer.dataLayer
    dataLayer.push({
      event: 'cFormSubmit',
      formName: formName
    })
  }
}

const addStepCompletion = (
  eventName: StepCompletionEventName,
  stepName: string
): void => {
  const windowWithDatalayer = window as any
  if (windowWithDatalayer.dataLayer) {
    const dataLayer = windowWithDatalayer.dataLayer
    dataLayer.push({
      event: eventName,
      // eslint-disable-next-line camelcase
      completed_step: stepName
    })
  }
}

const pushGTMEvent = (eventName: string, eventParams?: any): void => {
  const windowWithDatalayer = window as any
  if (windowWithDatalayer.dataLayer) {
    const dataLayer = windowWithDatalayer.dataLayer
    dataLayer.push({
      event: eventName,
      ...eventParams
    })
  }
}

export {
  initializeGTM,
  addPageView,
  addFormSubmit,
  addStepCompletion,
  pushGTMEvent
}
